import React from 'react';

const CompanySVG = ({ isActive }) => {
  if (isActive) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M5 6C5 5.44772 5.44772 5 6 5H7C7.55228 5 8 5.44772 8 6C8 6.55228 7.55228 7 7 7H6C5.44772 7 5 6.55228 5 6Z"
              fill="white" />
        <path d="M3 4C3 2.89543 3.89543 2 5 2H12C13.1046 2 14 2.89543 14 4V22H4C3.44771 22 3 21.5523 3 21V4Z"
              fill="#6FC5F2" />
        <path d="M14 10H20C21.1046 10 22 10.8954 22 12V21C22 21.5523 21.5523 22 21 22H14V10Z" fill="#4279DE" />
        <path d="M6 18C6 17.4477 6.44772 17 7 17H10C10.5523 17 11 17.4477 11 18V22H6V18Z" fill="#338CBB" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M16 16C16 15.4477 16.4477 15 17 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H17C16.4477 17 16 16.5523 16 16Z"
              fill="#173D84" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M16 19C16 18.4477 16.4477 18 17 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19Z"
              fill="#173D84" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M16 13C16 12.4477 16.4477 12 17 12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H17C16.4477 14 16 13.5523 16 13Z"
              fill="#173D84" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M5 9.39999C5 8.84771 5.44772 8.39999 6 8.39999H8C8.55228 8.39999 9 8.84771 9 9.39999C9 9.95228 8.55228 10.4 8 10.4H6C5.44772 10.4 5 9.95228 5 9.39999Z"
              fill="white" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M5 13.4C5 12.8477 5.44772 12.4 6 12.4H8C8.55228 12.4 9 12.8477 9 13.4C9 13.9523 8.55228 14.4 8 14.4H6C5.44772 14.4 5 13.9523 5 13.4Z"
              fill="white" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M5 5.39999C5 4.84771 5.44772 4.39999 6 4.39999H8C8.55228 4.39999 9 4.84771 9 5.39999C9 5.95228 8.55228 6.39999 8 6.39999H6C5.44772 6.39999 5 5.95228 5 5.39999Z"
              fill="white" />
        <path
          d="M12 5.39999C12 5.95228 11.5523 6.39999 11 6.39999C10.4477 6.39999 10 5.95228 10 5.39999C10 4.84771 10.4477 4.39999 11 4.39999C11.5523 4.39999 12 4.84771 12 5.39999Z"
          fill="white" />
        <path
          d="M12 9.39999C12 9.95228 11.5523 10.4 11 10.4C10.4477 10.4 10 9.95228 10 9.39999C10 8.84771 10.4477 8.39999 11 8.39999C11.5523 8.39999 12 8.84771 12 9.39999Z"
          fill="white" />
        <path
          d="M12 13.4C12 13.9523 11.5523 14.4 11 14.4C10.4477 14.4 10 13.9523 10 13.4C10 12.8477 10.4477 12.4 11 12.4C11.5523 12.4 12 12.8477 12 13.4Z"
          fill="white" />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M5 6C5 5.44772 5.44772 5 6 5H7C7.55228 5 8 5.44772 8 6C8 6.55228 7.55228 7 7 7H6C5.44772 7 5 6.55228 5 6Z"
            fill="white" />
      <path d="M3 4C3 2.89543 3.89543 2 5 2H12C13.1046 2 14 2.89543 14 4V22H4C3.44771 22 3 21.5523 3 21V4Z"
            fill="#C3C2C7" />
      <path d="M14 10H20C21.1046 10 22 10.8954 22 12V21C22 21.5523 21.5523 22 21 22H14V10Z" fill="#A5A3AD" />
      <path d="M6 18C6 17.4477 6.44772 17 7 17H10C10.5523 17 11 17.4477 11 18V22H6V18Z" fill="#2C2C2F" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M16 16C16 15.4477 16.4477 15 17 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H17C16.4477 17 16 16.5523 16 16Z"
            fill="#2C2C2F" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M16 19C16 18.4477 16.4477 18 17 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19Z"
            fill="#2C2C2F" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M16 13C16 12.4477 16.4477 12 17 12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H17C16.4477 14 16 13.5523 16 13Z"
            fill="#2C2C2F" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M5 9.39999C5 8.84771 5.44772 8.39999 6 8.39999H8C8.55228 8.39999 9 8.84771 9 9.39999C9 9.95228 8.55228 10.4 8 10.4H6C5.44772 10.4 5 9.95228 5 9.39999Z"
            fill="white" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M5 13.4C5 12.8477 5.44772 12.4 6 12.4H8C8.55228 12.4 9 12.8477 9 13.4C9 13.9523 8.55228 14.4 8 14.4H6C5.44772 14.4 5 13.9523 5 13.4Z"
            fill="white" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M5 5.39999C5 4.84771 5.44772 4.39999 6 4.39999H8C8.55228 4.39999 9 4.84771 9 5.39999C9 5.95228 8.55228 6.39999 8 6.39999H6C5.44772 6.39999 5 5.95228 5 5.39999Z"
            fill="white" />
      <path
        d="M12 5.39999C12 5.95228 11.5523 6.39999 11 6.39999C10.4477 6.39999 10 5.95228 10 5.39999C10 4.84771 10.4477 4.39999 11 4.39999C11.5523 4.39999 12 4.84771 12 5.39999Z"
        fill="white" />
      <path
        d="M12 9.39999C12 9.95228 11.5523 10.4 11 10.4C10.4477 10.4 10 9.95228 10 9.39999C10 8.84771 10.4477 8.39999 11 8.39999C11.5523 8.39999 12 8.84771 12 9.39999Z"
        fill="white" />
      <path
        d="M12 13.4C12 13.9523 11.5523 14.4 11 14.4C10.4477 14.4 10 13.9523 10 13.4C10 12.8477 10.4477 12.4 11 12.4C11.5523 12.4 12 12.8477 12 13.4Z"
        fill="white" />
    </svg>


  );
};

export default CompanySVG;
